import * as dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTable, useSortBy, usePagination, useFilters } from 'react-table';

import { TextFilter, RangeFilter } from 'components/Shared/Filters';

import Students from './Students';

const StudentsContainer = ({ students, ...props }) => {
  const { t } = useTranslation();
  const columns = useMemo(
    () => [
      {
        Header: t('Course/Teacher/Statistics/Students/name'),
        accessor: 'name',
        Filter: TextFilter,
        filter: 'text',
      },
      {
        Header: t('Course/Teacher/Statistics/Students/success'),
        accessor: 'success',
        Cell: ({ value }) => `${value}%`,
        Filter: RangeFilter,
        filter: 'between',
      },
      {
        Header: t('Course/Teacher/Statistics/Students/progression'),
        accessor: 'progression',
        Cell: ({ value }) => `${value}%`,
        Filter: RangeFilter,
        filter: 'between',
      },
      {
        Header: t('Course/Teacher/Statistics/Students/study-sessions'),
        accessor: 'nStudySessions',
        disableFilters: true,
      },
      {
        Header: t('Course/Teacher/Statistics/Students/average-study-session'),
        accessor: 'averageStudySessionMinutes',
        Cell: ({ value }) => `${value} min.`,
        disableFilters: true,
      },
      {
        Header: t('Course/Teacher/Statistics/Students/last-study-sessions'),
        accessor: 'lastStudySession',
        Cell: ({ value }) => (value ? dayjs(value).format('L') : ''),
        disableFilters: true,
      },
    ],
    [t],
  );
  const data = useMemo(() => students, [students]);
  const filterTypes = React.useMemo(
    () => ({
      text: (rows, id, filterValue) =>
        rows.filter((row) => {
          const rowValue = row.values[id];
          return rowValue !== undefined
            ? String(rowValue)
                .toLowerCase()
                .includes(String(filterValue).toLowerCase())
            : true;
        }),
    }),
    [],
  );
  const table = useTable(
    {
      columns,
      data,
      filterTypes,
      initialState: {
        pageIndex: 0,
        pageSize: 10,
      },
    },
    useFilters,
    useSortBy,
    usePagination,
  );
  const count = students.length;
  const [isSectionOpen, SetIsSectionOpen] = useState(false);
  const handleSectionToggle = useCallback(() => {
    SetIsSectionOpen(!isSectionOpen);
  }, [isSectionOpen]);
  return (
    <Students
      count={count}
      t={t}
      handleSectionToggle={handleSectionToggle}
      isSectionOpen={isSectionOpen}
      table={table}
      {...props}
    />
  );
};

StudentsContainer.propTypes = {
  students: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default StudentsContainer;
